import { Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import { useState } from "react";
import Grid from "@mui/material/Grid2";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import dayjs from "dayjs";
import MaterialBox from "../../../../components/MaterialBox";
import MaterialTypography from "../../../../components/MaterialTypography";
import MaterialSelect from "../../../../components/MasterSelect";
import { monthOptions, yearOptions } from "./CheckinCheckoutData";
import MaterialButton from "../../../../components/MaterialButton";
import axios from "axios";
import ConfirmationDialog from "../../../../components/Dialog/ConfirmationDialog";
import BASEURL from "../../../Utils/Baseurl";

const CheckinCheckoutReport = () => {

    const [open, setOpen] = useState(false);
    const [inputData, setInputData] = useState({
        month: "",
        year: "",
    });
    
    const [confirmationDialog, setConfirmationDialog] = useState({
        open: false,
        title: "",
        message: "",
        showCancel: true,
        showConfirm: true,
        customSection: null,
        onConfirm: () => {},
        onCancel: () => {},
    });

    //On Click API Function
    const handleDownloadReport = async() => {
        try{
            const response = await axios.post(
                BASEURL, { query: `
                query MonthlyUserwiseAttendance($month: Int!, $year: Int!) {
                    monthlyUserwiseAttendanceReport(month: $month, year: $year) {
                        empid
                        firstName
                        lastName
                        shift
                        totalWorkingHourCount
                        presentCount
                        absentCount
                        attendance {
                        date
                        checkIn
                        checkOut
                        totalWorkingHours
                        overtime
                        status
                        }
                    }
                }`,
                    variables: {
                        month: parseInt(inputData.month?.value), 
                        year: inputData.year?.value,
                    },
                },
                {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer YOUR_TOKEN_HERE`,
                },
                }
            );
            
            const responseData = response.data.data.monthlyUserwiseAttendanceReport
            if(responseData.length > 0) {
                handleDownloadPdf(responseData, inputData?.month?.label, inputData?.year?.value);
            }
            else{
                setOpen(false);
                setConfirmationDialog({
                    open: true,
                    title: "Notice",
                    message: "No records were found for the selected year and month.",
                    showCancel: true,
                    showConfirm: false,
                    onCancel: () => {
                        setConfirmationDialog({
                        ...confirmationDialog,
                        open: false,
                        });
                    },
                });
            }
        }   
        catch (error) {
            console.error("Error downloading report:", error);
            setConfirmationDialog({
                open: true,
                title: "Error message",
                message:
                "Sorry for your inconvience, there is some issue in our network. Please try again later.",
                showCancel: true,
                showConfirm: false,

                onCancel: () => {
                setConfirmationDialog({
                    ...confirmationDialog,
                    open: false,
                });
                },
            });
        }
    };

    //PDF UI and Download Function
    const handleDownloadPdf = (data, selectedMonth, selectedYear) => {
        const doc = new jsPDF();
        const today = dayjs().format("DD MMM YYYY HH:mm");
        const pageWidth = doc.internal.pageSize.getWidth();

        doc.setFontSize(14);
        const title = "Check-in Check-out Monthly Report";
        const textWidth = doc.getTextWidth(title);
        const centerX = (pageWidth - textWidth) / 2;
        doc.text(title, centerX, 15);

        doc.setFontSize(10);
        doc.text("Company: EMF", 14, 30);
        doc.text(`Printed On: ${today}`, pageWidth - 14, 30, { align: "right" });

        doc.setLineWidth(0.5);
        doc.line(14, 34, pageWidth - 14, 34);

        let finalY = 40;

        data.forEach((employee, index) => {
            const employeeName = `${employee.firstName} ${employee.lastName}`;
            const shift = employee.shift || "N/A";

            doc.setFontSize(10);
            finalY += 6;
            doc.text(
            `Employee Code: ${employee.empid}   Employee Name: ${employeeName}`,
            14,
            finalY
            );
            finalY += 4;

            const body = employee.attendance.map((entry) => [
            dayjs(entry.date).format("DD-MMM-YYYY"),
            entry.checkIn?.slice(11,16) || "--",
            entry.checkOut?.slice(11,16) || "--",
            shift,
            entry.totalWorkingHours || "--",
            entry.status || "--",
            "           ",
            ]);

            autoTable(doc, {
            startY: finalY + 2,
            head: [
                [
                "Date",
                "In Time",
                "Out Time",
                "Shift",
                "Total Duration",
                "Status",
                "Remarks",
                ],
            ],
            body,
            theme: "grid",
            headStyles: {
                fillColor: [200, 200, 200],
                textColor: 20,
                halign: "center",
            },
            styles: { fontSize: 9 },
            margin: { left: 14, right: 14 },
            });

            finalY = doc.lastAutoTable.finalY + 4;

            const summaryText = `Total Duration = ${employee.totalWorkingHourCount || "0"} hrs, Present Days = ${employee.presentCount}, Leaves = 0, Holiday = 0, Absent Days = ${employee.absentCount}, Week Off = 0`;
            doc.setFont("helvetica", "bold");
            doc.text(summaryText, 14, finalY);
            doc.setFont("helvetica", "normal");

            finalY += 10;

            if (finalY > 270 && index !== data.length - 1) {
            doc.addPage();
            finalY = 20;
            }
        });

        doc.save(`Monthly_Attendance_Report_${selectedMonth}_${selectedYear}.pdf`);
    };

    
  return (
    <>
    {confirmationDialog.open && (
    <ConfirmationDialog
        open={confirmationDialog.open}
        title={confirmationDialog.title}
        message={confirmationDialog.message}
        showCancel={confirmationDialog.showCancel}
        showConfirm={confirmationDialog.showConfirm}
        customSection={confirmationDialog.customSection}
        onConfirm={confirmationDialog.onConfirm}
        onCancel={confirmationDialog.onCancel}
    />
    )}
    <button
    onClick={() => setOpen(true)}
    style={{
          marginBottom: "10px",
          padding: "10px 12px",
          background: "#1d2a9eff",
          color: "#fff",
          border: "none",
          cursor: "pointer",
        }}>
            Check-in Check-out Report
    </button>
    <Dialog open={open}
        onClose={() => {
            setOpen(false);
            setInputData({
                month: "",
                year: "",
            });
        }}
    >

        <DialogTitle>
            Check-in Check-out Monthly Report
        </DialogTitle>
        <DialogContent>
            <MaterialBox mb={10}>
                <Grid container spacing={2}>
                     <Grid size={{ lg: 12, md:12, xs: 12, sm: 12 }}>
                        <MaterialBox lineHeight={0} display="inline-block">
                            <MaterialTypography
                                component="label"
                                variant="caption"
                                fontWeight="bold">
                                Choose Year
                            </MaterialTypography>
                        </MaterialBox>
                        <MaterialSelect
                        value={inputData.year}
                        onChange={(e) => setInputData({ ...inputData, year: e })}
                        name="year"
                        placeholder="Select Year"
                        options={yearOptions}
                        menuPlacement="auto"
                        />
                    </Grid>
                    <Grid size={{ lg:12, md: 12, xs: 12, sm: 12 }}>
                        <MaterialBox lineHeight={0} display="inline-block">
                            <MaterialTypography
                                component="label"
                                variant="caption"
                                fontWeight="bold"
                            >
                                Choose Month
                            </MaterialTypography>
                        </MaterialBox>
                        <MaterialSelect
                        value={inputData.month}
                        onChange={(e) => setInputData({ ...inputData, month: e })}
                        name="month"
                        placeholder="Select Month"
                        options={monthOptions}
                        menuPlacement="auto"
                        />
                    </Grid>            
                </Grid>
            </MaterialBox>
        </DialogContent>
        <DialogActions>
            <MaterialButton
            variant="gradient"
            color="dark"
            disabled={!inputData.month || !inputData.year}
            onClick={() => {
                handleDownloadReport();
            }}>
                Download Report
            </MaterialButton>
        </DialogActions>
    </Dialog>
    </>
  )
}

export default CheckinCheckoutReport